import { Globe } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES, type Language } from "@/src/common/locales/i18n";

export function LanguageFab() {
	const { i18n } = useTranslation();
	const [open, setOpen] = useState(false);

	const currentLanguage = i18n.language as Language;

	function switchLanguage(lang: Language) {
		i18n.changeLanguage(lang);
		setOpen(false);
	}

	return (
		<div className="fixed bottom-6 left-6 z-50">
			{open && (
				<div className="mb-2 flex flex-col gap-1 rounded-xl border border-app-border bg-app-surface-strong p-1.5 shadow-lg shadow-app-shadow/40 backdrop-blur-md">
					{(Object.entries(LANGUAGES) as [Language, string][]).map(([code, label]) => (
						<button
							key={code}
							type="button"
							onClick={() => switchLanguage(code)}
							className={`rounded-lg px-3.5 py-2 text-left text-sm font-medium transition-colors ${
								currentLanguage === code ? "bg-white/10 text-app-text" : "text-app-text-muted hover:bg-white/5 hover:text-app-text"
							}`}
						>
							{label}
						</button>
					))}
				</div>
			)}
			<button
				type="button"
				onClick={() => setOpen((prev) => !prev)}
				className="flex size-11 items-center justify-center rounded-full border border-app-border bg-app-surface-strong shadow-lg shadow-app-shadow/40 backdrop-blur-md transition-colors hover:bg-app-surface-muted"
				aria-label="Change language"
			>
				<Globe className="size-5 text-app-text-muted" />
			</button>
		</div>
	);
}
